
const SET_SESSION_TIMEOUT_MODAL_STATUS = (state, value) => {
  state.sessionTimeoutModalStatus = value;
};

export default {
  SET_SESSION_TIMEOUT_MODAL_STATUS,
};
